import type { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'

export type Transaction = NonNullable<
  Awaited<ReturnType<typeof MembershipsCreatorApiClient.getMemberChargesSubscriptions>>['data']
>['charges'][number]

export enum CancelRequestType {
  Schedule = 'Schedule',
  Now = 'Now',
}

export enum RefundRequestType {
  full = 'full',
  prorated = 'prorated',
  custom = 'custom',
}

export enum FormFields {
  transaction = 'transaction',
  refundRequestType = 'refundRequestType',
  customAmount = 'customAmount',
  cancelSubscription = 'cancelSubscription',
  cancelRequestType = 'cancelRequestType',
}

export type FormValues = {
  [FormFields.transaction]?: Transaction
  [FormFields.refundRequestType]: RefundRequestType
  [FormFields.customAmount]: string
  [FormFields.cancelSubscription]: boolean
  [FormFields.cancelRequestType]: CancelRequestType
}
